import { Editor } from 'grapesjs';
import { getAllComponents } from './reactComponentsRegistry/reactComponentsRegistry';

/**
 * Регистрирует React-компоненты в GrapesJS
 * @param editor Экземпляр редактора GrapesJS
 */
export function registerReactComponents(editor: Editor) {
  const components = getAllComponents();

  // Регистрируем каждый компонент из реестра
  components.forEach(compDef => {
    editor.DomComponents.addType(compDef.id, {
      extend: 'react-component',
      model: {
        defaults: {
          component: compDef.component,
          stylable: compDef.stylable,
          droppable: compDef.droppable,
          attributes: compDef.defaultAttributes,
          traits: compDef.traits,
        },
      },
      isComponent: el => el.tagName === compDef.tagName.toUpperCase(),
    });

    // Добавляем блок для компонента
    editor.BlockManager.add(compDef.id, compDef.block);
  });
}
